var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcon2 = function SvgIcon2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    fill: "#BC5252"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20.728 18.888h3.584V21h-6.32V9.768h2.736z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M10.723 11.152a.328.328 0 0 1 .554 0l.373.587a5.26 5.26 0 0 0 1.611 1.61l.587.374a.328.328 0 0 1 0 .554l-.587.373a5.26 5.26 0 0 0-1.61 1.612l-.374.586a.328.328 0 0 1-.554 0l-.373-.586a5.25 5.25 0 0 0-1.612-1.612l-.586-.373a.328.328 0 0 1 0-.554l.586-.373a5.25 5.25 0 0 0 1.612-1.611z"
  })));
};
export default SvgIcon2;